import { IWorkgroupActions, WorkgroupContext } from './actions.types';
import { IWorkgroupData } from '@/models';

export const actions: IWorkgroupActions = {
  fetchWorkgroups(context: WorkgroupContext): Promise<void> {
    return this.$services.workgroup
      .fetchWorkgroups()
      .then((workgroups: IWorkgroupData[]) => {
        context.commit('SET_WORKGROUPS', workgroups);
      });
  },

  fetchWorkgroup(context: WorkgroupContext, payload: number): Promise<void> {
    return this.$services.workgroup
      .fetchWorkgroup(payload)
      .then((workgroup: IWorkgroupData) => {
        const index = context.state.workgroups.findIndex(
          (v: IWorkgroupData) => v.id === workgroup.id
        );
        if (index === -1) {
          context.commit('ADD_WORKGROUP', workgroup);
        } else {
          context.commit('UPDATE_WORKGROUP', workgroup);
        }
      });
  },

  createWorkgroup(
    context: WorkgroupContext,
    payload: IWorkgroupData
  ): Promise<void> {
    return this.$services.workgroup
      .createWorkgroup(payload)
      .then((workgroup: IWorkgroupData) =>
        context.commit('ADD_WORKGROUP', workgroup)
      );
  },

  updateWorkgroup(
    context: WorkgroupContext,
    payload: IWorkgroupData
  ): Promise<void> {
    return this.$services.workgroup
      .updateWorkgroup(payload)
      .then((workgroup: IWorkgroupData) => {
        const index = context.state.workgroups.findIndex(
          (v: IWorkgroupData) => v.id === workgroup.id
        );
        if (index === -1) {
          context.commit('ADD_WORKGROUP', workgroup);
        } else {
          context.commit('UPDATE_WORKGROUP', workgroup);
        }
      });
  },

  deleteWorkgroup(context: WorkgroupContext, payload: number): Promise<void> {
    return this.$services.workgroup.deleteWorkgroup(payload).then(() => {
      context.commit('REMOVE_WORKGROUP', payload);
    });
  }
};
